import type { ComponentType, ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Estado vazio padrão: ícone opcional em "chip", título, descrição e uma ação
// (CTA). Substitui os textos cinza soltos — dá um próximo passo claro no 1º uso.
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ComponentType<{ className?: string }>
  title: string
  description?: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-1 px-6 py-14 text-center',
        className,
      )}
    >
      {Icon && (
        <div className="bg-primary/10 text-primary mb-3 flex size-12 items-center justify-center rounded-2xl">
          <Icon className="size-6" />
        </div>
      )}
      <h3 className="text-base font-semibold">{title}</h3>
      {description && <p className="text-muted-foreground max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
